import React from 'react';
import { ISpk } from './types';

interface ISpeakersRawProps {
  speakers: ISpk[];
}

export const SpeakersResult = (props: ISpeakersRawProps) => {
  return (
    <>
      <h3>Resultado </h3>

      <table className="table" style={{
        borderCollapse: 'collapse',
        width: '100%',
        border: '1px solid #dee2e6'
      }}>
        <thead>
          <tr>
            <th scope="col" style={{
              border: '1px solid #dee2e6',
              padding: '8px 12px',
              backgroundColor: '#f8f9fa',
              fontWeight: 'bold',
              textAlign: 'left'
            }}>#</th>
            <th scope="col" style={{
              border: '1px solid #dee2e6',
              padding: '8px 12px',
              backgroundColor: '#f8f9fa',
              fontWeight: 'bold',
              textAlign: 'left'
            }}>Nombre</th>
            <th scope="col" style={{
              border: '1px solid #dee2e6',
              padding: '8px 12px',
              backgroundColor: '#f8f9fa',
              fontWeight: 'bold',
              textAlign: 'left'
            }}>Apellido</th>
          </tr>
        </thead>
        <tbody>
          {props.speakers.map((spk: ISpk, idx: number) => (
            <tr key={JSON.stringify(spk) + idx}>
              <td style={{
                border: '1px solid #dee2e6',
                padding: '8px 12px',
                textAlign: 'center'
              }}>{idx}</td>
              <td style={{
                border: '1px solid #dee2e6',
                padding: '8px 12px'
              }}>{spk.name}</td>
              <td style={{
                border: '1px solid #dee2e6',
                padding: '8px 12px'
              }}>{spk.lastName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};
